import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Create a new context for navigation
const NavContext = createContext();

/**
 * Provider for the navigation context
 * @param {Object} props - The component props
 * @returns {JSX.Element} The NavContext provider component
 */
export const NavProvider = ({ children }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [navExpanded, setNavExpanded] = useState(true);

  // Toggle function for the navigation expansion
  const toggleNavExpanded = () => {
    setNavExpanded(prev => !prev);
  };

  // Handle new conversation creation
  const handleNewConversation = () => {
    navigate("/");
    // Add your new conversation logic here
    // This will be specific to your application
  };

  // Handle sending a prompt
  const handleSearchWithText = (text) => {
    navigate("/");
    // Add your search with text logic here
  };

  // Handle navigation to the networking page
  const handleNetworkingClick = () => {
    navigate('/networking');
  };

  return (
    <NavContext.Provider
      value={{
        navExpanded,
        toggleNavExpanded,
        handleNewConversation,
        handleSearchWithText,
        handleNetworkingClick
      }}
    >
      {children}
    </NavContext.Provider>
  );
};

/**
 * Custom hook to use the navigation context
 * @returns {Object} The navigation context
 */
export const useNav = () => {
  const context = useContext(NavContext);
  if (context === undefined) {
    throw new Error('useNav must be used within a NavProvider');
  }
  return context;
};